export default __webpack_public_path__ + "static/media/diagram1.8ee91e09.png";